import React from "react";
import AllServices from "../components/AllServices";
import ServiceBC from "../assets/img/servicebc.png";
import Button from "../components/Button";

export default function Services() {
  return (
    <>
      <div className="pt-10">
        <img src={ServiceBC} alt="" className="w-100 img-fluid" />
      </div>

      <div className="container pt-5 pb-2">
        <div className="row">
          <div className="col-md-12">
            <h2 className="pb-3 heading">Our Services</h2>
            <h4 className="subheading">
              {" "}
              From Concept to Completion, Seamlessly Delivered
            </h4>
            <p>
              At YANAA Homes, we believe great design begins with understanding
              your lifestyle. Our approach goes beyond aesthetics — we aim to
              deliver a seamless, end-to-end interior solution that reflects
              your personality and purpose. With a turnkey model that simplifies
              your journey, we manage every facet of your project — from initial
              concepts and material sourcing to execution and final detailing.
              Unlike traditional design studios, we take a comprehensive view,
              integrating services like electrical planning, custom carpentry,
              virtual collaboration, and consistent progress updates — all under
              one roof. Your vision is our blueprint, and we ensure every step
              is aligned with it.
            </p>
          </div>
        </div>
      </div>

      <AllServices />
      <div className="container pb-5 pt-3">
        <Button
          to="https://wa.me/917022851682/"
          title="Start Project"
          className="btn primary"
        />
      </div>
    </>
  );
}
